import { render, staticRenderFns } from "./carmsg.vue?vue&type=template&id=47841da6&scoped=true&"
import script from "./carmsg.vue?vue&type=script&lang=js&"
export * from "./carmsg.vue?vue&type=script&lang=js&"
import style0 from "./carmsg.vue?vue&type=style&index=0&id=47841da6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47841da6",
  null
  
)

export default component.exports